export const nevadaCountiesList = [
    'Carson City',
    'Churchill',
    'Clark',
    'Douglas',
    'Elko',
    'Esmeralda',
    'Eureka',
    'Humboldt',
    'Lander',
    'Lincoln',
    'Lyon',
    'Mineral',
    'Nye',
    'Pershing',
    'Storey',
    'Washoe',
    'White Pine',
    ]